/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const UserInputParser = /* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['tenantId', codecString, 'tenant_id'],
]);
export class UserInput extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UserInputParser.decode(input).map(res => new UserInput(res));
    }
    static unsafeDecode(input) {
        return UserInput.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UserInputParser.encode(data);
    }
    static schema() {
        return UserInputParser.schema();
    }
}
